import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import { UserAccess } from '../models/userModel';
import { BaseService } from './baseService';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class UserService extends BaseService{
    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

    public GetCurrentUser(): Promise<any> {       
        return this.httpget<any>('/Account/GetUserProfile');
    }

    public getJurisdictionUsers(jurisdictions:string[]): Promise<UserAccess[]> {
        const mapped = jurisdictions ? jurisdictions.map((j) => { return `&jurisdictions=${j !== null && !j.includes('Baltimore') ? j.replace(' County', '') : j}` }).join("") : "";
        return this.httpget(`/user/GetJurisdictionUsers/?${mapped}`);
    }
    public GetUserGroups(): Promise<any> {      
        return this.httpget<any>('/user/GetUserJurisdictions');
    }
}